<template>
	<v-col>
		<div class="d-flex justify-space-between">
			<div class="font-size-14 font-weight-bold secondary--text">Stokis &amp; Master Stokis</div>
		</div>
		<div class="mt-5">
			<v-row>
				<v-col cols="12">
					<v-card class="pa-3 elevation-0 rounded-xl hover-shadow">
						<v-tabs class="tabs-vo no-slider" v-model="activeTab">
							<v-tab
								class="rounded-xl"
								:disabled="tab_disabled"
								key="stokist"
								@click="changeTabStokis('stokist')">
								Daftar Stokis
							</v-tab>
							<v-tab
								class="rounded-xl"
								:disabled="tab_disabled"
								key="mstokist"
								@click="changeTabStokis('mstokist')">
								Daftar Master Stokis
							</v-tab>
						</v-tabs>
						<!-- <v-progress-circular
							indeterminate
							color="primary"
							v-else>
						</v-progress-circular> -->
					</v-card>
				</v-col>
			</v-row>
			<v-scroll-x-transition mode="in-out" :hide-on-leave="true">
				<template>
					<Stokist ref="stokisList" :stokis_type="stokis_type"></Stokist>
				</template>
			</v-scroll-x-transition>
		</div>
	</v-col>
</template>

<script>
// import { mapActions, mapState } from 'vuex'
import Stokist from './Stokist';

export default {
	components: {
		Stokist
	},
	data() {
		return {
			tab_disabled: false,
			stokis_type: 'stokist',
			activeTab: 0
		}
	},
	computed: {
	},
	methods: {

		changeTabStokis(type) {
			this.stokis_type = type
			this.tab_disabled = true
			setTimeout(() => {
				this.$refs.stokisList.getData()
			}, 200)
			setTimeout(() => {
				this.tab_disabled = false
			}, 500)
		},
	},
	created() {
		this.$store.dispatch('setPageTitle', `Stokis & Master Stokis`)
		// this.changeTabStokis('stokist')
		setTimeout(() => {
			this.$refs.stokisList.getData()
		}, 100)
	},
};
</script>